import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filter, includes, isArray, lowerCase, map, pick, toLower } from 'lodash/fp';
import { SegmentationBar as SegmentationBarView } from '@ahmdigital/ui';
import React from 'react';

import { ProductTypeType } from '../../types/product';
import { RootState } from '../../reducers';
import constants from '../../ahm-constants';
import CustomerActions from '../../actions/customer';
import getFrequencyOptions from '../../utils/get-frequency-options';
import getScaleOptions from '../../utils/get-scale-options';
import ModalActions from '../../actions/modal';
import PremiumReviewToggle from '../premium-review-toggle-wrapper';
import ProductListingOverlayActions from '../../actions/product-listing-overlay';
import selectCustomer from '../../selectors/select-customer';
import styles from './styles.module.sass';

const stateOptions = constants.STATE_OPTIONS;
const defaultScaleOptions = getScaleOptions({ endText: 'cover', format: toLower });
const frequencyOptions = getFrequencyOptions({ endText: 'ly', format: toLower });
const productTypeOptions = constants.PRODUCT_TYPE_OPTIONS;

type SegmentationBarProps = {
  actions: {};
  frequency: string;
  product?: {};
  productType: ProductTypeType;
  productTypes?: unknown[][];
  scale: string;
  showPremiumChangeDropdown?: boolean;
  showProductType?: boolean;
  state: string;
};

const SegmentationBar = ({
  actions,
  frequency,
  product,
  productType,
  productTypes,
  scale,
  showProductType,
  state,
}: SegmentationBarProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'scales' does not exist on type '{}'.
  const selectable = product?.scales?.selectable;

  const scaleOptions = selectable
    ? map((value) => ({ text: lowerCase(value), value }), selectable)
    : defaultScaleOptions;

  const filteredProductTypeOptions = isArray(productTypes)
    ? filter((option) => includes(option.value, productTypes), productTypeOptions)
    : productTypeOptions;

  const props = {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
    changeFrequency: actions?.customer?.changeFrequency,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
    changeProductType: actions?.customer?.changeProductType,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
    changeScale: actions?.customer?.changeScale,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'customer' does not exist on type '{}'.
    changeState: actions?.customer?.changeState,
    frequency,
    frequencyOptions,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'productListingOverlay' does not exist on type '{}'.
    onEdit: actions?.productListingOverlay?.productListingOverlayShowing,
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'productListingOverlay' does not exist on type '{}'.
    onRead: actions?.productListingOverlay?.productListingOverlayHidden,
    product,
    productType,
    productTypeOptions: filteredProductTypeOptions,
    scale,
    scaleOptions,
    showProductType,
    state,
    stateOptions,
  };

  return (
    <>
      <div className={styles.container}>
        <SegmentationBarView {...props} />
      </div>
      <div className={styles.toggleWrapper}>
        <PremiumReviewToggle showBackground />
      </div>
    </>
  );
};

SegmentationBar.defaultProps = {
  product: {},
  productTypes: null,
  showPremiumChangeDropdown: true,
  showProductType: true,
};

const mapStateToProps = (state: RootState) =>
  pick(['frequency', 'scale', 'state', 'productType'], selectCustomer(state));

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    customer: bindActionCreators(CustomerActions, dispatch),
    modal: bindActionCreators(ModalActions, dispatch),
    productListingOverlay: bindActionCreators(ProductListingOverlayActions, dispatch),
  },
});

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type '{ ({ actions, frequency, product, productType, productTypes, scale, showProductType, state, }: SegmentationBarProps): JSX.Element; defaultProps: { product: {}; productTypes: null; showPremiumChangeDropdown: boolean; showProductType: boolean; }; }' is not assignable to parameter of type 'JSXElementConstructor<Matching<Pick<Customer, "scale" | "productType" | "state" | "frequency"> & { actions: { customer: { changeAddress: (address: any) => { address: any; type: string; }; changeContinuousCover: (continuous: any, memberRelationship: any) => { ...; }; ... 15 more ...; changeSwitching: (switching: any)...'.
export default connect(mapStateToProps, mapDispatchToProps)(SegmentationBar);

export { SegmentationBar as SegmentationBarForTest, mapStateToProps, mapDispatchToProps };
